var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNearIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.55263 9.60696V16.4689L11.9737 13.8472L12.3158 14.1549L9.44701 18.2993C8.3811 19.3022 6.5 18.6236 6.5 17.2361V8.76385C6.5 7.32879 8.49123 6.67512 9.51893 7.77282L17.4474 16.2412V9.66084L14.3684 12.001L14.0263 11.6933L16.4664 7.82467C17.4848 6.70665 19.5 7.3544 19.5 8.79977V17.0844C19.5 18.5194 17.5088 19.1731 16.4811 18.0754L8.55263 9.60696Z",
    fill: "#332C4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNearIcon);
export default __webpack_public_path__ + "static/media/near-icon.a42136bd9e6ccd56a663a2a48390662c.svg";
export { ForwardRef as ReactComponent };